export function inactivityAlertDismissalKey(organisationId: string, scheduledDeactivationAt: string): string {
	return `whatsapp-inactivity-dismissed:${organisationId}:${scheduledDeactivationAt}`
}

export function shouldShowInactivityAlert({
	organisationId,
	scheduledDeactivationAt,
	whatsappEnabled,
	isDismissed,
}: {
	organisationId: string
	scheduledDeactivationAt: string | null
	whatsappEnabled: boolean
	isDismissed: (key: string) => boolean
}): boolean {
	if (!scheduledDeactivationAt || !whatsappEnabled) { return false }

	return !isDismissed(inactivityAlertDismissalKey(organisationId, scheduledDeactivationAt))
}
